import React from 'react';
import HeaderAR from './HeaderAR'
import BodyAR from './BodyAR'
import FooterAR from './FooterAR'
import FooterAR1 from './FooterAR1'

function AnpassadRBody(props) {
    const [listNumber,setListNumber]=React.useState(0)
    const checkListNumber=(index)=>{
        setListNumber(index)
    }
   
    return (
        <div style={{minHeight:'480px'}}>
        <div >
             <HeaderAR
             listNumber={listNumber}
             checkListNumber={checkListNumber}
             />
        </div>   
        <div style={{minHeight:"200px"}} className="p-2">
         <BodyAR
         listNumber={listNumber}
         Mstate={props.Mstate}
         onChangeMstate={props.onChangeMstate}
         OrderStatusList={props.OrderStatusList}
         />
        </div>   
        <div style={{minHeight:"100px"}} className="p-2">
         <FooterAR
          Mstate={props.Mstate}
          OrderStatusList={props.OrderStatusList}
         />
        </div>   
        <div className="p-2">
        <FooterAR1
          Mstate={props.Mstate}
         />
        </div>
        
        
        </div>
    );
}
export default AnpassadRBody;